import { ResourceType } from "../LeftPanel/ExtractAdd/Types";

export const APP_EXTRACT = "extractsBuilder";
export const APP_FEASIBILITY = "feasibilityApp";
export const FEASIBILITY_CODELIST = {
  [ResourceType.GenericCodeList] : "75e7c350-0e21-431a-912b-0aa85f01a4d8",
  [ResourceType.GenericDrugList] : "59654339-72d4-41a1-9bcd-6186b6128735",
  [ResourceType.GenericEthnicList] : "5ad9bea1-0e0c-45d4-acab-0efa897597cc",
};
